<app-header></app-header>

<main class="pulsewatch-container">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
